<template>
  <transition-group name="modal-fade" tag="div">
    <div key="background" v-if="modalActive" class="modal-screen" @click="closeBackgroundModal"></div>
    <div key="body" role="dialog" aria-label="modal pop up" v-if="modalActive" class="modal">
      <button class="close non-button-style" aria-label="close modal" @click="closeBackgroundModal" v-if="allowClose && backgroundCloseModal" />
      <div v-if="header" class="modal-header">
        <h2>{{ header }}</h2>
        <hr />
      </div>
      <slot name="modalContent"></slot>
    </div>
  </transition-group>
</template>

<script>
export default {
  emits: ['closeBackgroundModal'],
  props: {
    backgroundCloseModal: {
      type: Boolean,
      default: true,
    },
    modalActive: {
      type: Boolean,
      required: true,
    },
    header: {
      type: String,
      required: false,
    },
    /**
     * Prop to determine if the modal can be closed or not. If false, the close button and clicking outside will not close the modal.
     * Default is true.
     */
    allowClose: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    closeBackgroundModal() {
      if (this.backgroundCloseModal && this.allowClose) {
        const isModalVisible = false;
        this.$emit('closeBackgroundModal', isModalVisible);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
